export default "__VITE_ASSET__B37ERZzO__"